namespace GeniuzPOS.ReportMasterData {
    export class Report_1318Columns {
        static columnsKey = 'ReportMasterData.Report_1318';
    }
}
